__turbopack_context__.v({
  "clearButton": "filter-module-scss-module__Te6FPa__clearButton",
  "count": "filter-module-scss-module__Te6FPa__count",
  "drawerPanelText": "filter-module-scss-module__Te6FPa__drawerPanelText",
  "drawerResetButton": "filter-module-scss-module__Te6FPa__drawerResetButton",
  "form": "filter-module-scss-module__Te6FPa__form",
  "root": "filter-module-scss-module__Te6FPa__root",
});
